import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import ScreenAdaptTransform from './utils/screenAdapt'
Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.use(ScreenAdaptTransform, {
  baseWidth: 1920,
  minZoom: 0.5,
  maxZoom: 1.2,
  debounceTime: 100
})
Vue.prototype.$imgurl=function(url){	
  if(url&&url!=''){
    if(url.indexOf('data:')!=-1||url.indexOf('http')!=-1||url.indexOf('https')!=-1){
      return url
    }else{
      return 'https://yixue.cgwzjs.com'+url
    }
  }
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
